import React, { lazy, Suspense } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  Redirect,
} from "react-router-dom";
import { connect } from "react-redux";
import Loader from "../../components/loader";
import Register from "../../containers/SignUp";
import { Row, Col } from "antd";
import { AiOutlineTwitter, FaFacebookF, FaLinkedinIn } from "react-icons/all";
import ExpiredLink from "../../containers/SignUp/expiredlink";
import SurfaceLogo from '../../assets/images/surface-logo.png'


class Routes extends React.Component {
  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      window.scrollTo(0, 0);
    }
  }

  render() {
    return (
      <Suspense fallback={<Loader />}>
        <Switch>
          <React.Fragment>
            {!(!!window?.location?.pathname?.includes('expired_link') || !!window?.location?.pathname?.includes('404')) &&
              <Row>
                <Col
                  span={24}
                  style={{ padding: "0.8rem", background: "#383A3D" }}
                >
                  <Row align="middle" justify="space-between">
                    <Col xl={6} lg={8} md={8} xs={24} sm={24}>
                      <img
                        width="60%"
                        src={SurfaceLogo}
                      />
                    </Col>
                    {/* <Col xl={12}>
                      <Row align="midlle">
                        <Col xl={4}>
                          <a
                            href="https://www.surface-tech.com/about-m/"
                            target="_blank"
                          >
                            <h4 className="color-white navbar-font-family">
                              ABOUT
                            </h4>
                          </a>
                        </Col>
                        <Col xl={4}>
                          <a
                            href="https://www.surface-tech.com/asphalt-overview-2/"
                            target="_blank"
                          >
                            <h4 className="color-white navbar-font-family ">
                              ASPHALT
                            </h4>
                          </a>
                        </Col>
                        <Col xl={4}>
                          <a
                            href="https://www.surface-tech.com/concrete_platform_2017/"
                            target="_blank"
                          >
                            <h4 className="color-white navbar-font-family ">
                              CONCRETE
                            </h4>
                          </a>
                        </Col>
                        <Col xl={7}>
                          <a
                            href="https://surface-tech.com/trkr-overview/"
                            target="_blank"
                          >
                            <h4 className="color-white navbar-font-family ">
                              SOFTWARE SOLUTIONS
                            </h4>
                          </a>
                        </Col>
                        <Col xl={5}>
                          <a
                            href="https://www.surface-tech.com/contact-2017/"
                            target="_blank"
                          >
                            <h4 className="color-white navbar-font-family ">
                              CONTACT
                            </h4>
                          </a>
                        </Col>
                      </Row>
                    </Col>
                    <Col xl={4}>
                      <Row>
                        <Col xl={4}>
                          <a
                            target={"_blank"}
                            href="https://twitter.com/SurfaceTech_LLC"
                          >
                            <AiOutlineTwitter color="white" size="25" />
                          </a>
                        </Col>
                        <Col xl={4}>
                          <a
                            target={"_blank"}
                            href="https://www.facebook.com/Surface-Tech-211543822585857/"
                          >
                            <FaFacebookF color="white" size="25" />
                          </a>
                        </Col>
                        <Col xl={4}>
                          <a
                            href="https://www.linkedin.com/company/10687685/"
                            target={"_blank"}
                          ></a>
                          <FaLinkedinIn color="white" size="25" />
                        </Col>
                      </Row>
                    </Col> */}
                  </Row>
                </Col>
              </Row>
            }
            <Switch>
              <Route exact path="/expired_link" component={ExpiredLink} />
              <Route exact path="/register" component={Register} />
              <Route path="*" render={() => <Redirect to="/register" />} />
            </Switch>
            {/* <Switch>
              <Route exact path='/expired_link' render={() => <div></div>}></Route>
              <Route path='*' render={() => <Register />}></Route>
            </Switch> */}
          </React.Fragment>
        </Switch>
      </Suspense>
    );
  }
}

// const ProtectedRoute = ({ enabled, ...props }) => (
//   enabled && <Route {...props} />
// )

export default connect((storeState) => {
  return {};
})(Routes);
